import { Modal } from 'components/Modal';
import { Restricted } from 'components/Restricted';
import { EndFocus } from 'components/buttons/EndFocus';
import { SkipContentButton } from 'components/buttons/SkipContentButton';
import { PrimaryButton } from 'components/buttons/v4';
import { ContentTable } from 'components/content/ContentTable';
import { CreateModal } from 'components/modals/create-flow/CreateModal';
import { ContentSection, PageContainer, PageTitle, TitleSection } from 'core/layout';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { MutableRefObject, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const ContentPage = () => {
  const { t } = useTranslation();
  const endFocusRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [contentTableResetSort, setContentTableResetSort] = useState<(() => void) | null>(null);

  const handleCreateClick = () => {
    setShowCreateModal(true);
  };

  const handleCreateModalClose = () => {
    setShowCreateModal(false);
  };

  const handleSetCreated = () => {
    if (contentTableResetSort) {
      contentTableResetSort();
    }
  };

  useDocumentTitle(t('All Content'));

  return (
    <MainFrame>
      <PageContainer>
        <TitleSection>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <PageTitle>{t('All Content')}</PageTitle>
            <SkipContentButton endFocusRef={endFocusRef} />
          </div>
          <Restricted
            allowedRoles={['admin', 'course manager', 'content manager']}
            component={<PrimaryButton click={handleCreateClick}>{t('+ Create')}</PrimaryButton>}
          />
        </TitleSection>
        <ContentSection>
          <ContentTable registerSortReset={setContentTableResetSort} />
          <EndFocus endFocusRef={endFocusRef} />
        </ContentSection>
      </PageContainer>

      {showCreateModal && (
        <CreateModal onClose={handleCreateModalClose} onSetCreated={handleSetCreated} />
      )}
    </MainFrame>
  );
};

const MainFrame = styled.div`
  height: 100vh;
  display: flex;
  flex-grow: 1;
  border: none;
`;